import { frontendURL } from 'dashboard/helper/URLHelper.js';

import MediaLibraryPage from './pages/MediaLibraryPage.vue';

const meta = {
  permissions: ['administrator', 'agent'],
};

const mediaRoutes = {
  routes: [
    {
      path: frontendURL('accounts/:accountId/media'),
      name: 'media_library_index',
      meta,
      component: MediaLibraryPage,
    },
  ],
};

export default mediaRoutes;
